/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Upload } from '@atoms';
import { MediaLibraryModal } from '@molecules';

const FileSelect = ({
  file,
  onChange,
  dropAreaText,
  title = 'Upload file',
  accept,
  disabled,
  showUploadArea = !file,
  children,
}) => {
  const uploadProps = { onChange, accept, disabled };

  return (
    <>
      <MediaLibraryModal.Heading>
        <MediaLibraryModal.Title extra={<Upload.Button {...uploadProps} />}>{title}</MediaLibraryModal.Title>
      </MediaLibraryModal.Heading>
      {children}
      {showUploadArea && <Upload.Area label={dropAreaText} {...uploadProps} />}
    </>
  );
};

export default FileSelect;
